import moment from "moment";
import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

export interface StressEntryDetails {
  isReset: any;
  selectedStressType: any;
  selectedStressProcedure: any;
  selectedStressLinkedAssets: any;
  submittedSerialNumber: string;
  cleared: boolean;
  stage: number;
  scannedUnits: any;
  checkedUnits: Map<string, any>;
  checkedUnitsTable: any[];
  permission: any;
  stressEntryDate: any;
  mode: number | null;
  isCalibrated: any;
  isCalibrationReady: boolean;
  entries: any[];
  stressCalibrationDate: any;
  lightExposure: string | null;
  irradiance: string | null;
  averageTemperature: number | null;
  loadType: string | null;
  fixed_resistor_value: number | null;
  DampheatCalibration_date: any;
  DampheatTest_duration: number | null;
  DampheatTest_humidity: number | null;
  DampheatWeights: number | null;
  DampheatTest_temperature: number | null;
  CidCalibration_date: any;
  CidTest_duration: number | null;

  CidTest_temperature: number | null;
  CidCurrent_is_normal: boolean | null;
  PidCalibration_date: string | null;
  PidTest_duration: number | null;
  PidTest_humidity: number | null;
  PidTest_temperature: number | null;
  PidVoltage_is_normal: boolean | null;
  TCCalibration_date: any;
  TCTest_duration: number | null;
  TCTest_condition: string | null;
  TCApplied_current: number | null;
  TCVoltage_is_normal: boolean | null;
  TCNumber_of_TestCycles: number | null;
  TCweight: number | null;
  HFCalibration_date: any;
  HFTest_temperature: string | null;
  HFTest_humidity: number | null;
  HFApplied_current: number | null;
  HFVoltage_is_normal: boolean | null;
  HFNumber_of_TestCycles: number | null;
  UVAB_irradiance: number | null;
  UVAB_total_dose: number | null;
  UVB_irradiance_ratio: number | null;
  Type_of_light_source: string | null;
  DUT_operating_condition: string | null;
  DUT_exposed_surface: string | null;
  Set_temperature: number | null;
  Temperature_control_mode: string | null;
  UVIDCalibration_date: any;
  DUT_average_temperature: number | null;
  DMLAmbient_temperature: number | null;
  DMLAmbient_humidity: number | null;
  DMLCalibration_date: any;
  DMLInstallation_method: string | null;
  DMLMounting_hardware: string | null;
  DMLTest_pressure: number | null;
  DMLNumber_of_test_cycles: number | null;
  DMLTotal_Number_of_test_cycles: number | null;
  DMLDUT_circuit_check_normal: boolean;
  LetidTest_duration: number | null;
  LetidTest_temperature: number | null;
  LetidCalibration_date: any;
  LetidCurrent_is_normal: boolean;
  HTAmbient_temperature: number | null;
  HTAmbient_humidity: number | null;
  HTCalibration_date: any;
  HTShot_position: string | null;
  HTIce_ball_mass: number | null;
  HTIce_ball_diameter: number | null;
  HTIce_ball_speed: number | null;
  HTHail_test_specs: number | null;
  HTMounting_method: string;
  HTMounting_tilt: number | null;
  SMLAmbient_temperature: number | null;
  SMLAmbient_humidity: number | null;
  SMLCalibration_date: any;
  SMLInstallation_method: string | null;
  SMLMounting_hardware: string | null;
  SMLTest_pressure: number | null;
  SMLTest_direction: string | null;
  SMLDUT_deflection: number | null;
  SMLTest_duration: number | null;
  SMLLoad_uniformity: number | null;
  SMLcircuit_check_normal: boolean;
  isDAMPHeatCheck: boolean | null;
  isThermalCyclingCheck: boolean | null;
  isCidTestCheck: boolean | null;
  isLetidTestCheck: boolean | null;
  isLightSoakCheck: boolean | null;
  isPidTestCheck: boolean | null;
  isHailTestCheck: boolean | null;
  isUvidTestCheck: boolean | null;
  isHumidityTestCheck: boolean | null;
  isDMLTestCheck: boolean | null;
  isSMLTestCheck: boolean | null;
  procedureResultIds:
    | {
        procedureResultId: number;
        procedureDefinitionName: string;
      }[]
    | null;
  unitVersion: {
    version?: string;
    results?: {
      procedure_result_id: number;
      apply_current: number | null;
      message: string | null;
    }[];
  } | null;
  isProcedureCheck: boolean | null;
  Applied_currentHF: number | null;
  Applied_currentCID: number | null;
  selectedFiles: File[];
  Sml_file_id: number | null;
  smlImages: File[];
  SmlFailtype: string | null;
  actionApiResponse: any;
}

const initialState: StressEntryDetails = {
  cleared: false,
  stage: 0,
  selectedStressType: null,
  selectedStressProcedure: null,
  selectedStressLinkedAssets: [],
  scannedUnits: new Map(),
  checkedUnits: new Map(),
  checkedUnitsTable: [],
  submittedSerialNumber: "",
  permission: null,
  stressEntryDate: moment().format("YYYY-MM-DD HH:mm:ss"),
  mode: null,
  isCalibrated: null,
  isCalibrationReady: false,
  isReset: true,
  entries: [],
  stressCalibrationDate: null,
  lightExposure: "",
  irradiance: null,
  averageTemperature: null,
  loadType: "",
  fixed_resistor_value: null,
  DampheatCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  DampheatTest_duration: null,
  DampheatTest_humidity: null,
  DampheatTest_temperature: null,
  DampheatWeights: null,
  CidCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  CidTest_duration: null,
  CidTest_temperature: null,
  CidCurrent_is_normal: false,
  PidCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  PidTest_duration: null,
  PidTest_humidity: null,
  PidTest_temperature: null,
  PidVoltage_is_normal: false,
  TCCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  TCTest_duration: null,
  TCTest_condition: null,
  TCApplied_current: null,
  TCVoltage_is_normal: false,
  TCNumber_of_TestCycles: null,
  TCweight: null,
  HFCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  HFTest_temperature: null,
  HFTest_humidity: null,
  HFApplied_current: null,
  HFVoltage_is_normal: false,
  HFNumber_of_TestCycles: null,
  UVAB_irradiance: null,
  UVAB_total_dose: null,
  UVB_irradiance_ratio: null,
  Type_of_light_source: "",
  DUT_operating_condition: null,
  DUT_exposed_surface: null,
  Set_temperature: null,
  Temperature_control_mode: "",
  UVIDCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  DUT_average_temperature: null,
  DMLAmbient_temperature: null,
  DMLAmbient_humidity: null,
  DMLCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  DMLInstallation_method: "",
  DMLMounting_hardware: "",
  DMLTest_pressure: null,
  DMLNumber_of_test_cycles: null,
  DMLTotal_Number_of_test_cycles: null,
  DMLDUT_circuit_check_normal: false,
  LetidTest_duration: null,
  LetidTest_temperature: null,
  LetidCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  LetidCurrent_is_normal: false,
  HTAmbient_temperature: null,
  HTAmbient_humidity: null,
  HTCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  HTShot_position: "",
  HTIce_ball_mass: null,
  HTIce_ball_diameter: null,
  HTIce_ball_speed: null,
  HTHail_test_specs: null,
  HTMounting_method: "",
  HTMounting_tilt: null,
  SMLAmbient_temperature: null,
  SMLAmbient_humidity: null,
  SMLCalibration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  SMLInstallation_method: "",
  SMLMounting_hardware: "",
  SMLTest_pressure: null,
  SMLTest_direction: null,
  SMLTest_duration: null,
  SMLDUT_deflection: null,
  SMLLoad_uniformity: null,
  SMLcircuit_check_normal: false,
  isDAMPHeatCheck: false,
  isThermalCyclingCheck: false,
  isCidTestCheck: false,
  isLetidTestCheck: false,
  isLightSoakCheck: false,
  isPidTestCheck: false,
  isHailTestCheck: false,
  isUvidTestCheck: false,
  isHumidityTestCheck: false,
  isDMLTestCheck: false,
  isSMLTestCheck: false,
  procedureResultIds: null,
  unitVersion: null,
  isProcedureCheck: false,
  Applied_currentHF: 0.1,
  Applied_currentCID: null,
  selectedFiles: [],
  Sml_file_id: null,
  smlImages: [],
  SmlFailtype: "",
  actionApiResponse: null,
};

// Actions
type Action =
  | { type: "SET_SUBMITTED_SERIAL_NUMBER"; payload: { serialNumber: string } }
  | { type: "SET_SELECTED_STRESS_TYPE"; payload: { selectedStressType: any } }
  | {
      type: "SET_SELECTED_STRESS_PROCEDURE";
      payload: { selectedStressProcedure: any };
    }
  | {
      type: "SET_SELECTED_STRESS_LINKED_ASSETS";
      payload: { selectedStressLinkedAssets: any };
    }
  | {
      type: "NEXT_STAGE";
    }
  | { type: "PREVIOUS_STAGE" }
  | { type: "ADD_SCANNED_UNIT"; payload: { unit: any } }
  | { type: "REMOVE_SCANNED_UNIT"; payload: { id: string } }
  | {
      type: "ADD_CHECKED_UNIT";
      payload: {
        unit: any;
        procedureResult: any;
        sibling: any;
        siblings?: any[];
      };
    }
  | {
      type: "SET_UPDATED_CHECKED_UNITS_TABLE";
      payload: { updatedCheckedUnitsTable: any[]; serialNumber: string };
    }
  | {
      type: "SET_UPDATED_METADATA";
      payload: { metadata: string; serialNumber: string };
    }
  | { type: "CLEAN_STRESS_ENTRY" }
  | { type: "CLEAN_LINKED_ASSETS" }
  | { type: "RESET_SERIAL_NUMBER"; payload: { reset: any } }
  | { type: "CLEAN_SCANNED_UNITS" }
  | {
      type: "SET_STRESS_ENTRY_DATE";
      payload: { date: any };
    }
  | {
      type: "SET_PERMISSION";
      payload: { permission: any };
    }
  | {
      type: "SET_CALIBRATION_DATE";
      payload: { date: any };
    }
  | {
      type: "DAMPHEAT_STRESS_DETAILS";
      payload: {
        Calibration_date: string | null;
        Test_duration: number | null;
        Test_humidity: number | null;
        Test_temperature: number | null;
        weight: number | null;
      };
    }
  | {
      type: "CID_STRESS_DETAILS";
      payload: {
        Calibration_date: string;
        Test_duration: number | null;
        Test_temperature: number | null;
        Current_is_normal: boolean | null;
      };
    }
  | {
      type: "PID_STRESS_DETAILS";
      payload: {
        Calibration_date: string;
        Test_duration: number | null;
        Test_humidity: number | null;
        Test_temperature: number | null;
        Voltage_is_normal: boolean | null;
      };
    }
  | {
      type: "TC_STRESS_DETAILS";
      payload: {
        Calibration_date: string | null;
        Test_duration: number | null;
        Test_condition: string | null;
        Voltage_is_normal: boolean;
        NumberofCycles: number | null;
        weight: number | null;
      };
    }
  | {
      type: "HF_STRESS_DETAILS";
      payload: {
        Calibration_date: string;
        Test_temperature: string | null;
        Test_humidity: number | null;
        Applied_current: number | null;
        Voltage_is_normal: boolean | null;
        Number_of_TestCycles: number | null;
      };
    }
  | {
      type: "UVID_STRESS_DETAILS";
      payload: {
        UVAB_irradiance: number | null;
        UVAB_total_dose: number | null;
        UVB_irradiance_ratio: number | null;
        Type_of_light_source: string;
        DUT_operating_condition: string | null;
        DUT_exposed_surface: null;
        Set_temperature: number | null;
        Temperature_control_mode: string;
        Calibration_date: string | null;
        DUT_average_temperature: number | null;
      };
    }
  | {
      type: "DML_STRESS_DETAILS";
      payload: {
        Ambient_temperature: number | null;
        Ambient_humidity: number | null;
        Calibration_date: string;
        Installation_method: string;
        Mounting_hardware: string;
      };
    }
  | {
      type: "DML_STRESS_OUT_DETAILS";
      payload: {
        Test_pressure: number | null;
        Number_of_test_cycles: number | null;
        Total_Number_of_test_cycles: number | null;
        DUT_circuit_check_normal: boolean;
      };
    }
  | {
      type: "LETID_STRESS_DETAILS";
      payload: {
        Test_duration: number | null;
        Test_temperature: number | null;
        Calibration_date: string;
        Current_is_normal: boolean;
      };
    }
  | {
      type: "HAILTEST_STRESS_DETAILS";
      payload: {
        Ambient_temperature: number | null;
        Ambient_humidity: number | null;
        Calibration_date: string | null;

        Hail_test_specs: number | null;
        Mounting_method: string;
        Mounting_tilt: number | null;
      };
    }
  | {
      type: "HAILTEST_STRESS_EXIT_DETAILS";
      payload: {
        entries: any[];
      };
    }
  | {
      type: "SML_STRESS_DETAILS";
      payload: {
        Ambient_temperature: number | null;
        Ambient_humidity: number | null;
        Calibration_date: string | null;
        Installation_method: string;
        Mounting_hardware: string;
      };
    }
  | {
      type: "SMLTEST_STRESS_EXIT_DETAILS";
      payload: {
        entries: any[];
      };
    }
  | {
      type: "SET_IS_DAMP_HEAT_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_THERMAL_CYCLING_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_CID_TEST_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_LETID_TEST_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_LIGHT_SOAK_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_PID_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_HAIL_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_UVID_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_HUMIDITY_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_DML_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_IS_SML_CHECK";
      payload: boolean | null;
    }
  | {
      type: "SET_STRESS_EXPOSURE_DETAILS";
      payload: {
        light_exposure: string;
        irradiance?: string | null;
        load_type: string;
        fixed_resistor_value?: number | null;
      };
    }
  | {
      type: "SET_STRESS_OUT_EXPOSURE_DETAILS";
      payload: {
        average_temperature: number | null;
      };
    }
  | {
      type: "SET_UNIT_VERSION";
      payload: {
        unitVersion: {
          version?: string;
          results?: {
            procedure_result_id: number;
            apply_current: number | null;
            message: string | null;
          }[];
        } | null;
      };
    }
  | {
      type: "SET_PROCEDURE_RESULT_IDS";
      payload: {
        procedures: {
          procedureResultId: number;
          procedureDefinitionName: string;
        }[];
      };
    }
  | {
      type: "SET_APPLIED_CURRENT_HF";
      payload: {
        applied_current: number;
      };
    }
  | {
      type: "SET_APPLIED_CURRENT_CID";
      payload: {
        applied_current: number;
      };
    }
  | {
      type: "SET_UPDATED_LOW_CURRENT";
      payload: { lowCurrent: string; serialNumber: string };
    }
  | {
      type: "SET_ISCALIBRATED";
      payload: { calibrateInfo: any };
    }
  | { type: "SET_CALIBRATION_READY"; payload: boolean }
  | {
      type: "SET_SELECTED_FILES";
      payload: { files: File[] };
    }
  | {
      type: "SET_SML_FILE_ID";
      payload: {
        Sml_file_id: number;
      };
    }
  | {
      type: "SET_SML_IMAGES";
      payload: { Sml_images: File[] };
    }
  | {
      type: "SET_SMLFAIL";
      payload: {
        FailureType: string;
        serialNumber: string;
      };
    }
  | {
      type: "SET_ACTION_API_RESPONSE";
      payload: { actionApiResponse: any };
    }
  | {
      type: "SET_MODE";
      payload: number | null;
    };

// Reducer

const stressEntryDetailsReducer = (
  draft: StressEntryDetails,
  action: Action,
): StressEntryDetails => {
  switch (action.type) {
    case "SET_SUBMITTED_SERIAL_NUMBER": {
      draft.submittedSerialNumber = action.payload.serialNumber;
      return draft;
    }
    case "SET_SELECTED_STRESS_TYPE": {
      draft.selectedStressType = action.payload.selectedStressType;
      return draft;
    }
    case "SET_SELECTED_STRESS_PROCEDURE": {
      draft.selectedStressProcedure = action.payload.selectedStressProcedure;
      return draft;
    }
    case "SET_SELECTED_STRESS_LINKED_ASSETS": {
      draft.selectedStressLinkedAssets =
        action.payload.selectedStressLinkedAssets;
      return draft;
    }
    case "ADD_SCANNED_UNIT": {
      draft.scannedUnits.set(
        action.payload.unit.serial_number,
        action.payload.unit,
      );
      return draft;
    }
    case "REMOVE_SCANNED_UNIT": {
      draft.submittedSerialNumber = "";
      draft.scannedUnits.delete(action.payload.id);
      return draft;
    }

    case "ADD_CHECKED_UNIT": {
      const { unit, procedureResult, sibling, siblings } = action.payload;
      const metadataItems =
        siblings && siblings.length > 1 ? siblings : [sibling];

      draft.checkedUnits.set(unit.serial_number, {
        ...procedureResult,
        sibling, // unchanged — anything else reading `.sibling` still works
        siblings: metadataItems, // new
      });

      metadataItems.forEach((_, i) => {
        draft.checkedUnitsTable.push({
          ...unit,
          procedureType: draft.selectedStressProcedure?.name,
          metadataIndex: i, // new — tells the NAME/METADATA cells which sibling belongs to this row
        });
      });
      return draft;
    }
    case "SET_UPDATED_CHECKED_UNITS_TABLE": {
      draft.checkedUnitsTable = action.payload.updatedCheckedUnitsTable;
      draft.checkedUnits.delete(action.payload.serialNumber);
      return draft;
    }
    case "SET_UPDATED_METADATA": {
      const currentCheckedUnit = draft.checkedUnits.get(
        action.payload.serialNumber,
      );
      draft.checkedUnits.set(action.payload.serialNumber, {
        ...currentCheckedUnit,
        metadata: action.payload.metadata,
      });
      return draft;
    }
    case "SET_STRESS_ENTRY_DATE": {
      draft.stressEntryDate = action.payload.date.format("YYYY-MM-DD HH:mm:ss");
      return draft;
    }
    case "SET_MODE": {
      draft.mode = action.payload;
      return draft;
    }
    case "SET_PERMISSION": {
      draft.permission = action.payload.permission ? true : false;
      return draft;
    }
    case "NEXT_STAGE": {
      draft.stage++;
      return draft;
    }
    case "PREVIOUS_STAGE": {
      draft.stage++;
      return draft;
    }
    case "CLEAN_STRESS_ENTRY":
      let currentState = draft.mode;
      draft = { ...initialState, mode: currentState };

      return draft;
    case "CLEAN_SCANNED_UNITS":
      draft.scannedUnits.clear();
      draft.submittedSerialNumber = "";
      return draft;
    case "CLEAN_LINKED_ASSETS":
      draft.selectedStressLinkedAssets = [];
      return draft;
    case "SET_ISCALIBRATED": {
      draft.isCalibrated = action.payload.calibrateInfo;
      return draft;
    }
    case "SET_CALIBRATION_READY": {
      draft.isCalibrationReady = action.payload;
      return draft;
    }

    case "RESET_SERIAL_NUMBER": {
      draft.isReset = action.payload.reset;
      return draft;
    }
    case "SET_CALIBRATION_DATE": {
      draft.stressCalibrationDate = action.payload.date
        ? action.payload.date.format("YYYY-MM-DD HH:mm:ss")
        : null;
      return draft;
    }

    case "DAMPHEAT_STRESS_DETAILS": {
      draft.DampheatCalibration_date = action.payload.Calibration_date;
      draft.DampheatTest_humidity = action.payload.Test_humidity;
      draft.DampheatTest_duration = action.payload.Test_duration || null;
      draft.DampheatTest_temperature = action.payload.Test_temperature;
      draft.DampheatWeights = action.payload.weight || null;
      return draft;
    }
    case "CID_STRESS_DETAILS": {
      draft.CidCalibration_date = action.payload.Calibration_date;
      draft.CidTest_duration = action.payload.Test_duration;
      draft.CidTest_temperature = action.payload.Test_temperature;
      draft.CidCurrent_is_normal = action.payload.Current_is_normal;
      return draft;
    }
    case "PID_STRESS_DETAILS": {
      draft.PidCalibration_date = action.payload.Calibration_date;
      draft.PidTest_duration = action.payload.Test_duration;
      draft.PidTest_temperature = action.payload.Test_temperature;
      draft.PidTest_humidity = action.payload.Test_humidity;
      draft.PidVoltage_is_normal = action.payload.Voltage_is_normal;

      return draft;
    }
    case "TC_STRESS_DETAILS": {
      draft.TCCalibration_date = action.payload.Calibration_date;
      draft.TCTest_duration = action.payload.Test_duration;
      draft.TCTest_condition = action.payload.Test_condition;
      draft.TCVoltage_is_normal = action.payload.Voltage_is_normal;
      draft.TCNumber_of_TestCycles = action.payload.NumberofCycles;
      draft.TCweight = action.payload.weight;

      return draft;
    }
    case "HF_STRESS_DETAILS": {
      draft.HFCalibration_date = action.payload.Calibration_date;
      draft.HFTest_humidity = action.payload.Test_humidity;
      draft.HFTest_temperature = action.payload.Test_temperature;
      draft.HFApplied_current = action.payload.Applied_current;
      draft.HFVoltage_is_normal = action.payload.Voltage_is_normal;
      draft.HFNumber_of_TestCycles = action.payload.Number_of_TestCycles;

      return draft;
    }

    case "UVID_STRESS_DETAILS": {
      draft.UVAB_irradiance = action.payload.UVAB_irradiance;
      draft.UVAB_total_dose = action.payload.UVAB_total_dose;
      draft.UVB_irradiance_ratio = action.payload.UVB_irradiance_ratio;
      draft.Type_of_light_source = action.payload.Type_of_light_source;
      draft.DUT_operating_condition = action.payload.DUT_operating_condition;
      draft.DUT_exposed_surface = action.payload.DUT_exposed_surface;
      draft.Set_temperature = action.payload.Set_temperature;
      draft.Temperature_control_mode = action.payload.Temperature_control_mode;
      draft.UVIDCalibration_date = action.payload.Calibration_date;
      draft.DUT_average_temperature = action.payload.DUT_average_temperature;

      return draft;
    }
    case "DML_STRESS_DETAILS": {
      draft.DMLAmbient_humidity = action.payload.Ambient_humidity;
      draft.DMLAmbient_temperature = action.payload.Ambient_temperature;
      draft.DMLCalibration_date = action.payload.Calibration_date;
      draft.DMLInstallation_method = action.payload.Installation_method;
      draft.DMLMounting_hardware = action.payload.Mounting_hardware;

      return draft;
    }
    case "DML_STRESS_OUT_DETAILS": {
      draft.DMLTest_pressure = action.payload.Test_pressure;
      draft.DMLNumber_of_test_cycles = action.payload.Number_of_test_cycles;
      draft.DMLTotal_Number_of_test_cycles =
        action.payload.Total_Number_of_test_cycles;
      draft.DMLDUT_circuit_check_normal =
        action.payload.DUT_circuit_check_normal;

      return draft;
    }

    case "LETID_STRESS_DETAILS": {
      draft.LetidTest_duration = action.payload.Test_duration;
      draft.LetidTest_temperature = action.payload.Test_temperature;
      draft.LetidCalibration_date = action.payload.Calibration_date;
      draft.LetidCurrent_is_normal = action.payload.Current_is_normal;

      return draft;
    }

    case "HAILTEST_STRESS_DETAILS": {
      draft.HTAmbient_temperature = action.payload.Ambient_temperature;
      draft.HTAmbient_humidity = action.payload.Ambient_humidity;
      draft.HTCalibration_date = action.payload.Calibration_date;

      draft.HTHail_test_specs = action.payload.Hail_test_specs;
      draft.HTMounting_method = action.payload.Mounting_method;
      draft.HTMounting_tilt = action.payload.Mounting_tilt;

      return draft;
    }

    case "HAILTEST_STRESS_EXIT_DETAILS": {
      draft.entries = action.payload.entries;
      return draft;
    }

    case "SML_STRESS_DETAILS": {
      draft.SMLAmbient_humidity = action.payload.Ambient_humidity;
      draft.SMLAmbient_temperature = action.payload.Ambient_temperature;
      draft.SMLCalibration_date = action.payload.Calibration_date;
      draft.SMLInstallation_method = action.payload.Installation_method;
      draft.SMLMounting_hardware = action.payload.Mounting_hardware;

      return draft;
    }
    case "SMLTEST_STRESS_EXIT_DETAILS": {
      draft.entries = action.payload.entries;
      return draft;
    }
    case "SET_IS_LIGHT_SOAK_CHECK":
      draft.isLightSoakCheck = action.payload;
      return draft;
    case "SET_IS_DAMP_HEAT_CHECK":
      draft.isDAMPHeatCheck = action.payload;
      return draft;
    case "SET_IS_THERMAL_CYCLING_CHECK":
      draft.isThermalCyclingCheck = action.payload;
      return draft;
    case "SET_IS_CID_TEST_CHECK":
      draft.isCidTestCheck = action.payload;
      return draft;
    case "SET_IS_LETID_TEST_CHECK":
      draft.isLetidTestCheck = action.payload;
      return draft;
    case "SET_IS_PID_CHECK":
      draft.isPidTestCheck = action.payload;
      return draft;
    case "SET_IS_HAIL_CHECK":
      draft.isHailTestCheck = action.payload;
      return draft;

    case "SET_IS_UVID_CHECK":
      draft.isUvidTestCheck = action.payload;
      return draft;

    case "SET_IS_HUMIDITY_CHECK":
      draft.isHumidityTestCheck = action.payload;
      return draft;
    case "SET_IS_DML_CHECK":
      draft.isDMLTestCheck = action.payload;
      return draft;
    case "SET_IS_SML_CHECK":
      draft.isSMLTestCheck = action.payload;
      return draft;
    case "SET_STRESS_EXPOSURE_DETAILS": {
      draft.lightExposure = action.payload.light_exposure;
      draft.irradiance = action.payload.irradiance || null;

      draft.loadType = action.payload.load_type;
      draft.fixed_resistor_value = action.payload.fixed_resistor_value || null;
      return draft;
    }
    case "SET_STRESS_OUT_EXPOSURE_DETAILS": {
      draft.averageTemperature = action.payload.average_temperature || null;

      return draft;
    }

    case "SET_UNIT_VERSION": {
      draft.unitVersion = action.payload.unitVersion;
      return draft;
    }
    case "SET_PROCEDURE_RESULT_IDS": {
      draft.procedureResultIds = action.payload.procedures;
      return draft;
    }

    case "SET_APPLIED_CURRENT_HF": {
      draft.Applied_currentHF = action.payload.applied_current ?? 0.1;
      return draft;
    }
    case "SET_APPLIED_CURRENT_CID": {
      draft.Applied_currentCID = action.payload.applied_current;
      return draft;
    }

    case "SET_UPDATED_LOW_CURRENT": {
      const { lowCurrent, serialNumber } = action.payload;
      const current = draft.checkedUnits.get(serialNumber);
      draft.checkedUnits.set(serialNumber, {
        ...current,
        lowCurrent,
      });
      return draft;
    }

    case "SET_ACTION_API_RESPONSE": {
      draft.actionApiResponse = action.payload.actionApiResponse;
      return draft;
    }

    case "SET_SELECTED_FILES":
      draft.selectedFiles = action.payload.files;
      return draft;
    case "SET_SML_FILE_ID": {
      draft.Sml_file_id = action.payload.Sml_file_id;
      return draft;
    }
    case "SET_SML_IMAGES": {
      draft.smlImages = action.payload.Sml_images;
      return draft;
    }
    case "SET_SMLFAIL": {
      const { FailureType, serialNumber } = action.payload;
      const current = draft.checkedUnits.get(serialNumber);
      draft.checkedUnits.set(serialNumber, {
        ...current,
        FailureType,
      });
      return draft;
    }
    default: {
      return draft;
    }
  }
};

interface StressEntryDetailsContextProps {
  state: StressEntryDetails;
  dispatch: React.Dispatch<Action>;
}

const StressEntryDetailsContext = createContext<StressEntryDetailsContextProps>(
  {} as StressEntryDetailsContextProps,
);

export const StressEntryDetailsContextProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const [state, dispatch] = useImmerReducer(
    stressEntryDetailsReducer,
    initialState,
  );

  return (
    <StressEntryDetailsContext.Provider value={{ state, dispatch }}>
      {children}
    </StressEntryDetailsContext.Provider>
  );
};

export const useStressEntryContext = () => {
  return useContext(StressEntryDetailsContext);
};
